import { createSelector } from 'reselect';
import path from 'ramda/es/path';

import config from 'app/config';


export type Person = {
  id: number,
  name: {
    first: string,
    last: string,
    middle: string,
    gender: 'male' | 'female' | 'androgynous',
  },
  timezone: string,
}

const selectPerson: (state: any, id: string) => Person = createSelector(
  [
    (state, id) => path(['students', 'data', id], state) || {},
  ],
  (student) => {
    const { accountId, name, gender, timezone } = student;
    return {
      id: accountId,
      name: {
        ...name,
        gender: gender || 'androgynous',
      },
      timezone: timezone || config.defaultTimezone,
    };
  }
);

export default selectPerson
